/**
 * dev-flags — ВРЕМЕННЫЕ флаги для ручного теста (через URL-параметры).
 *
 * ⚠⚠ УДАЛИТЬ ПЕРЕД ЗАПУСКОМ В ПРОД (owner-directive 2026-05-30: пока оставляем для
 * тестирования). Затрагивает ОБА dev-роута:
 *   - `?dev=daily` (этот флаг) — заход доски дня → result СКОЛЬКО УГОДНО раз сегодня,
 *     в обход «одна попытка в день» и без реальной отправки на сервер (mock-вердикт
 *     «Зачтено»). Нужен, т.к. реальный минутный период требует миграции БД.
 *   - `?dev=resetdaily` (в app.ts) — чистит клиентский кэш доски дня.
 * Перед продом удалить: этот файл + обе ветки в app.ts + dev-daily mock в board-screen
 * finalizeGame. Это обход анти-чита — в прод НЕЛЬЗЯ.
 */

// Считываем ОДИН РАЗ при загрузке модуля (на boot), ДО того как startDailyGame
// затрёт query-строку через history.replaceState (анти-чит: daily-seed не в URL).
// Иначе к моменту finalizeGame `?dev=daily` уже пропадёт и сабмит уйдёт реальным.
const DEV_DAILY =
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('dev') === 'daily';

/** `?dev=daily` — режим теста доски дня (локальный заход + mock-вердикт). */
export function isDevDaily(): boolean {
  return DEV_DAILY;
}

// [ВРЕМЕННО — снять после починки realme] `?vfitdebug` / `#vfitdebug` — on-screen
// плашка с замером rail-подгонки на экране итогов (owner код не читает; фотографирует
// числа с реального устройства). Тоже читаем на boot, ДО зачистки URL приложением.
const VFIT_DEBUG =
  typeof window !== 'undefined' &&
  (new URLSearchParams(window.location.search).has('vfitdebug') ||
    window.location.hash.includes('vfitdebug'));

/** `?vfitdebug` — диагностическая плашка замера на экране итогов (временная). */
export function isVfitDebug(): boolean {
  return VFIT_DEBUG;
}

// [ВРЕМЕННЫЙ DEV-РОУТ — снять перед продом] `?demo=achievementwindow` (owner-запрос
// 2026-06-22 «ссылка как у гнома») — грузит экран итогов с мок-ачивками + окошко над
// доской PERSISTENT (auto-dismiss ВЫКЛ) для осмотра/скриншота. Читаем на boot ДО зачистки
// URL приложением: result-screen передаёт окошку autoDismiss:false при этом флаге. Реальный
// поток конца партии сохраняет авто-уход 3000ms. Удалить вместе с веткой `?demo=achievementwindow`.
const DEMO_ACHIEVEMENT_WINDOW =
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('demo') === 'achievementwindow';

/** `?demo=achievementwindow` — демо-режим окошка ачивок (persistent, без авто-ухода). */
export function isDemoAchievementWindow(): boolean {
  return DEMO_ACHIEVEMENT_WINDOW;
}

// `&reduced=1` при демо-окошке ачивок — мгновенный показ без анимации появления/ухода
// (зеркало `?demo=helperunlock&reduced=1`). Читаем на boot вместе с флагом выше.
const DEMO_ACHIEVEMENT_WINDOW_REDUCED =
  DEMO_ACHIEVEMENT_WINDOW &&
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('reduced') === '1';

/** `?demo=achievementwindow&reduced=1` — демо без анимации (reduce-motion). */
export function isDemoAchievementWindowReduced(): boolean {
  return DEMO_ACHIEVEMENT_WINDOW_REDUCED;
}
